import React, { AnchorHTMLAttributes } from 'react';

export interface ViewCard {
  // TODO This might be a type from GQL.
  id: string;
}

export interface BoardViewContextValue {
  // TODO Feel free to add or remove as necessary.
  getCards: () => ViewCard[];
  navigateToCard: (cardUrl: string) => void;
  getLinkToCardProps: (
    cardUrl: string,
    onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void,
  ) => Partial<AnchorHTMLAttributes<HTMLAnchorElement>>;

  closeView?: () => void;
}

export const BoardViewContext = React.createContext<BoardViewContextValue>({
  getCards: () => [],
  navigateToCard: () => {},
  getLinkToCardProps: (cardUrl: string) => ({}),
});
